import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import BudgetTypeDetail from '@app/views/BudgetType/Detail';
import { memo } from 'react';

export default memo(
  withIfUser(BudgetTypeDetail)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
